export default __webpack_public_path__ + "static/media/course1.a7687e08.JPG";